import axios from 'axios';
import querystring from 'querystring';
import { createStore } from 'redux';
import authreducers from "../store/reducer/auth";
// import { connect } from 'react-redux';
import jwt from 'jsonwebtoken'
import { logout } from '../store/action/auth';



const store = createStore(authreducers); // redux api for get store without using connect

const token = localStorage.getItem('token');
const exptime = new Date(localStorage.getItem('expireIn'));
const now = new Date();

// // validasi jika token expired
const condition = now.getTime() > exptime.getTime();
let data_user = null;

if (condition) {
  store.dispatch(logout());
}

function getToken() {
  const JWT_DECODE = jwt.verify(localStorage.getItem('token'), 'secretmasojodibukak');
  const COMPANY = JSON.parse(localStorage.getItem('company')); 
  
  return data_user = {
    userId: JWT_DECODE.userId,
    nameUser: JWT_DECODE.nameUser,
    name_company: JWT_DECODE.name_company,
    companyId: JWT_DECODE.companyId,
    branchId: COMPANY !== null  ? COMPANY.branch : null,
    createdBy: JWT_DECODE.nameUser + ' (' + JWT_DECODE.userId + ')',
    updatedBy: JWT_DECODE.nameUser + ' (' + JWT_DECODE.userId + ')',
  }
}




// console.log(object)

// membuat middleware agar bisa akses state store redux di non connectfunction

// const data_user = {
// userId: store.userId,
// nameUser: store.nameUser,
// name_company: store.name_company,
// companyId: store.companyId,
// createdBy: store.nameUser + ' (' + store.userId + ')',
// updatedBy: store.nameUser + ' (' + store.userId + ')',
// }

const HOSTNAME = process.env.REACT_APP_API_URL || 'http://localhost:8080';

const API_SERVICES = {
  Login: `${HOSTNAME}/auth/login`,
  CheckEmail: `${HOSTNAME}/auth/checkemail`,
  SignUp: `${HOSTNAME}/auth/signup`,
  ListEmployee: `${HOSTNAME}/auth/listem`,

  ProductIndex: `${HOSTNAME}/product/index`,
  ProductAdd: `${HOSTNAME}/product/add`,
  ProductEdit: `${HOSTNAME}/product/edit`,
  ProductUpdate: `${HOSTNAME}/product/update`,
  ProductDelete: `${HOSTNAME}/product/delete`,

  //journal produk
ProductIndexJournal : `${HOSTNAME}/product/indexjurnal`,
ProductAddJournal: `${HOSTNAME}/product/addjurnal`,
ProductEditJournal: `${HOSTNAME}/product/editjurnal`,
ProductUpdateJournal: `${HOSTNAME}/product/updatejurnal`,
ProductDeleteJournal: `${HOSTNAME}/product/deletejurnal`,

//ebook produk
ProductIndexEbook : `${HOSTNAME}/product/indexebook`,
ProductAddEbook : `${HOSTNAME}/product/addebook`,
ProductEditEbook : `${HOSTNAME}/product/editebook`,
ProductUpdateEbook : `${HOSTNAME}/product/updateebook`,
ProductDeleteEbook : `${HOSTNAME}/product/deleteebook`,

//imprint api
ProductIndeximprint : `${HOSTNAME}/product/indeximprint`,
ProductAddimprint : `${HOSTNAME}/product/addimprint`,
ProductEditimprint : `${HOSTNAME}/product/editimprint`,
ProductUpdateimprint : `${HOSTNAME}/product/updateimprint`,
ProductDeleteimprint : `${HOSTNAME}/product/deleteimprint`,

//ihsan api
  ProductIndexihsan : `${HOSTNAME}/product/indexihsan`,
  ProductAddihsan : `${HOSTNAME}/product/addihsan`,
  ProductEditihsan : `${HOSTNAME}/product/editihsan`,
  ProductUpdateihsan : `${HOSTNAME}/product/updateihsan`,
  ProductDeleteihsan : `${HOSTNAME}/product/deleteihsan`,

  //inspirasi api
  ProductIndexinspirasi : `${HOSTNAME}/product/indexinspirasi`,
  ProductAddinspirasi : `${HOSTNAME}/product/addinspirasi`,
  ProductEditinspirasi : `${HOSTNAME}/product/editinspirasi`,
  ProductUpdateinspirasi : `${HOSTNAME}/product/updateinspirasi`,
  ProductDeleteinspirasi : `${HOSTNAME}/product/deleteinspirasi`,

   //idea api
  ProductIndexidea : `${HOSTNAME}/product/indexidea`,
  ProductAddidea : `${HOSTNAME}/product/addidea`,
  ProductEditidea : `${HOSTNAME}/product/editidea`,
  ProductUpdateidea : `${HOSTNAME}/product/updateidea`,
  ProductDeleteidea : `${HOSTNAME}/product/deleteidea`,




  ProductCategoryGeneral: `${HOSTNAME}/category/general`,
  ProductPenerbitGeneral : `${HOSTNAME}/product/penerbit`,
  ProductCategory: `${HOSTNAME}/category`,
  CategoryProductLocalAdd: `${HOSTNAME}/category/add`,
  AuthorIndex: `${HOSTNAME}/author`,
  AuthorCreate: `${HOSTNAME}/author/add`,
  MaterialIndex: `${HOSTNAME}/material`,
  MaterialCreate: `${HOSTNAME}/material/add`,
  SlideBarCreate: `${HOSTNAME}/slidebar/add`,
  SlideBarGet: `${HOSTNAME}/slidebar/index`,
  SlideBarUpdate: `${HOSTNAME}/slidebar/update`,
  SlideBarDelete: `${HOSTNAME}/slidebar/delete`,
  ListPayment: `${HOSTNAME}/orderproduct/subtotal`,
  WaitingPayment: `${HOSTNAME}/orderproduct/waiting`,
  SliderPublisherCreate: `${HOSTNAME}/slider-publisher/add`,
  SliderPublisherGet: `${HOSTNAME}/slider-publisher/index`,
  SliderPublisherUpdate: `${HOSTNAME}/slider-publisher/update`,
  SliderPublisherDelete: `${HOSTNAME}/slider-publisher/delete`,


  ConfirmPayment: `${HOSTNAME}/order/updatepayment`,
  RejurnalPayment:`${HOSTNAME}/order/rejurnalpayment`,
  FindTransactionId: `${HOSTNAME}/orderproduct/transaction`,
  // modul ADMIN STORE untuk search Order yang sudah dikonfirmasi
  ListStatus: `${HOSTNAME}/order/list-status`,
  ListOrder: `${HOSTNAME}/orderproduct/searchorder`,
  ListOrderDetail: `${HOSTNAME}/orderproduct/searchorderdetail`,
  UpdateResi: `${HOSTNAME}/order/updateSending`,
  TakeThisOrder: `${HOSTNAME}/orderproduct/take-this-order`,
  DeclineThisOrder: `${HOSTNAME}/orderproduct/decline-this-order`,
  TrackingShip: `${HOSTNAME}/district-recomendation/tracking`,
  DashboardStat: `${HOSTNAME}/dashboard/index`,
  CategoryListCompany: `${HOSTNAME}/category/company`,
  BranchList: `${HOSTNAME}/auth/list-branch`,
  SetBranchSetting: `${HOSTNAME}/auth/set-branch-setting`,
  CheckBranchChosen: `${HOSTNAME}/auth/is-company-model-exsist`,
  CheckAccountFinance: `${HOSTNAME}/product/check-account-finance`,
}

const configFetch = (url, method, body, isJSON = false, extraHeaders = {}) => ({
  method,
  url,
  data: isJSON ? body : querystring.stringify(body),
  headers: {
    'Content-Type': isJSON ? 'application/json' : 'application/x-www-form-urlencoded',
    'Accept': 'application/json',
    ...extraHeaders
  }
});


// API PRODUCT
const ProductList = (contents) => {

  getToken();

  const content = {
    ...contents,
    ...data_user
  }

  const page = contents.page ? contents.page : 1;
  const limit = contents.limit ? contents.limit : 10;
  const sortby = contents.sortby ? contents.sortby : "name";
  const order = contents.order ? contents.order : "ASC";
  const name = contents.name ? contents.name : "";

  const url = API_SERVICES.ProductIndex + "/?page=" + page + "&limit=" + limit + "&sortby=" + sortby + "&name=" + name + "&orderby=" + order;
  return axios(configFetch(url, 'get', content)).then(result => result.data).catch(err => console.log(err))
}

//API PRODUCT EBOOK
const ProductListEbook = (contents) => {
  getToken();

  const content = {
    ...contents,
    ...data_user
  }

  const page = contents.page ? contents.page : 1;
  const limit = contents.limit ? contents.limit : 10;
  const sortby = contents.sortby ? contents.sortby : "name";
  const order = contents.order ? contents.order : "ASC";
  const name = contents.name ? contents.name : "";

  const url = API_SERVICES.ProductIndexEbook + "/?page=" + page + "&limit=" + limit + "&sortby=" + sortby + "&name=" + name + "&orderby=" + order;
  return axios(configFetch(url, 'get', content)).then(result => result.data).catch(err => console.log(err))


}

//API PRODUCT IMPRINT

const ProductListImprint = (contents) => {
  getToken();

  const content = {
    ...contents,
    ...data_user
  }

  const page = contents.page ? contents.page : 1;
  const limit = contents.limit ? contents.limit : 10;
  const sortby = contents.sortby ? contents.sortby : "name";
  const order = contents.order ? contents.order : "ASC";
  const name = contents.name ? contents.name : "";

  const url = API_SERVICES.ProductIndeximprint + "/?page=" + page + "&limit=" + limit + "&sortby=" + sortby + "&name=" + name + "&orderby=" + order;
  return axios(configFetch(url, 'get', content)).then(result => result.data).catch(err => console.log(err))
}

//API PRODUCT IHSAN

const ProductListIhsan = (contents) => {
  getToken();

  const content = {
    ...contents,
    ...data_user
  }

  const page = contents.page ? contents.page : 1;
  const limit = contents.limit ? contents.limit : 10;
  const sortby = contents.sortby ? contents.sortby : "name";
  const order = contents.order ? contents.order : "ASC";
  const name = contents.name ? contents.name : "";

  const url = API_SERVICES.ProductIndexihsan + "/?page=" + page + "&limit=" + limit + "&sortby=" + sortby + "&name=" + name + "&orderby=" + order;
  return axios(configFetch(url, 'get', content)).then(result => result.data).catch(err => console.log(err))
}

//API PRODUCT INSPIRASI

const ProductListInspirasi = (contents) => {
  getToken();

  const content = {
    ...contents,
    ...data_user
  }

  const page = contents.page ? contents.page : 1;
  const limit = contents.limit ? contents.limit : 10;
  const sortby = contents.sortby ? contents.sortby : "name";
  const order = contents.order ? contents.order : "ASC";
  const name = contents.name ? contents.name : "";

  const url = API_SERVICES.ProductIndexinspirasi + "/?page=" + page + "&limit=" + limit + "&sortby=" + sortby + "&name=" + name + "&orderby=" + order;
  return axios(configFetch(url, 'get', content)).then(result => result.data).catch(err => console.log(err))
}

//API PRODUCT IDEA

const ProductListIdea = (contents) => {
  getToken();

  const content = {
    ...contents,
    ...data_user
  }

  const page = contents.page ? contents.page : 1;
  const limit = contents.limit ? contents.limit : 10;
  const sortby = contents.sortby ? contents.sortby : "name";
  const order = contents.order ? contents.order : "ASC";
  const name = contents.name ? contents.name : "";

  const url = API_SERVICES.ProductIndexidea + "/?page=" + page + "&limit=" + limit + "&sortby=" + sortby + "&name=" + name + "&orderby=" + order;
  return axios(configFetch(url, 'get', content)).then(result => result.data).catch(err => console.log(err))
}


//API PRODUCT JOURNAL
const ProductListJournal = (contents) => {

  getToken();

  const content = {
    ...contents,
    ...data_user
  }

  const page = contents.page ? contents.page : 1;
  const limit = contents.limit ? contents.limit : 10;
  const sortby = contents.sortby ? contents.sortby : "name";
  const order = contents.order ? contents.order : "ASC";
  const name = contents.name ? contents.name : "";

  const url = API_SERVICES.ProductIndexJournal + "/?page=" + page + "&limit=" + limit + "&sortby=" + sortby + "&name=" + name + "&orderby=" + order;
  return axios(configFetch(url, 'get', content)).then(result => result.data).catch(err => console.log(err))
}


const ProductAdd = (contents) => {

  getToken();

  const content = {
    ...contents,
    ...data_user
  }

  console.log(content)

  const url = API_SERVICES.ProductAdd;
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  }

  return axios(configFetch(url, 'post', content, true, extraHeaders))
    .then(result => result.data)
    .catch(err => console.log(err))
}

const FindTransactionId = (contents) => {
  getToken();
  const content = {
    ...contents,
    ...data_user
  }

  const url = API_SERVICES.FindTransactionId;
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  }


  return axios(configFetch(url, 'post', content, true, extraHeaders)) 
    .then(result => result.data)
    .catch(err => console.log(err))
}

//ebook add

const ProductAddEbook = (contents) => {
  getToken();

  const content = {
    ...contents,
    ...data_user
  }

  console.log(content)

  const url = API_SERVICES.ProductAddEbook;
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  }

  return axios(configFetch(url, 'post', content, true, extraHeaders))
    .then(result => result.data)
    .catch(err => console.log(err))

  
}

//imprint add
const ProductAddimprint = (contents) => {
  getToken();

  const content = {
    ...contents,
    ...data_user
  }

  console.log(content)

  const url = API_SERVICES.ProductAddimprint;
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  }

  return axios(configFetch(url, 'post', content, true, extraHeaders))
    .then(result => result.data)
    .catch(err => console.log(err))

  
}

//ihsan add
const ProductAddihsan = (contents) => {
  getToken();

  const content = {
    ...contents,
    ...data_user
  }

  console.log(content)

  const url = API_SERVICES.ProductAddihsan;
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  }

  return axios(configFetch(url, 'post', content, true, extraHeaders))
    .then(result => result.data)
    .catch(err => console.log(err))

  
}

//inspirasi add
const ProductAddinspirasi = (contents) => {
  getToken();

  const content = {
    ...contents,
    ...data_user
  }

  console.log(content)

  const url = API_SERVICES.ProductAddinspirasi;
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  }

  return axios(configFetch(url, 'post', content, true, extraHeaders))
    .then(result => result.data)
    .catch(err => console.log(err))

  
}
//end add

//idea add
const ProductAddidea = (contents) => {
  getToken();

  const content = {
    ...contents,
    ...data_user
  }

  console.log(content)

  const url = API_SERVICES.ProductAddidea;
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  }

  return axios(configFetch(url, 'post', content, true, extraHeaders))
    .then(result => result.data)
    .catch(err => console.log(err))

  
}
//end add


//start edit
const ProductEdit = (contents) => {

  getToken();
  const content = {
    ...contents,
    ...data_user
  }

  const url = API_SERVICES.ProductEdit;
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  }

  return axios(configFetch(url, 'post', content, true, extraHeaders))
    .then(result => result.data)
    .catch(err => console.log(err))
}

//edit ebook

const ProductEditEbook = (contents) => {

  getToken();
  const content = {
    ...contents,
    ...data_user
  }

  const url = API_SERVICES.ProductEditEbook;
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  }

  return axios(configFetch(url, 'post', content, true, extraHeaders))
    .then(result => result.data)
    .catch(err => console.log(err))
}

//edit imprint
const ProductEditimprint = (contents) => {

  getToken();
  const content = {
    ...contents,
    ...data_user
  }

  const url = API_SERVICES.ProductEditimprint;
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  }

  return axios(configFetch(url, 'post', content, true, extraHeaders))
    .then(result => result.data)
    .catch(err => console.log(err))
}

//edit ihsan
const ProductEditihsan = (contents) => {

  getToken();
  const content = {
    ...contents,
    ...data_user
  }

  const url = API_SERVICES.ProductEditihsan;
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  }

  return axios(configFetch(url, 'post', content, true, extraHeaders))
    .then(result => result.data)
    .catch(err => console.log(err))
}
//end edit 

//edit inspirasi
const ProductEditinspirasi = (contents) => {

  getToken();
  const content = {
    ...contents,
    ...data_user
  }

  const url = API_SERVICES.ProductEditinspirasi;
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  }

  return axios(configFetch(url, 'post', content, true, extraHeaders))
    .then(result => result.data)
    .catch(err => console.log(err))
}
//end edit

//edit idea
const ProductEditidea= (contents) => {

  getToken();
  const content = {
    ...contents,
    ...data_user
  }

  const url = API_SERVICES.ProductEditidea;
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  }

  return axios(configFetch(url, 'post', content, true, extraHeaders))
    .then(result => result.data)
    .catch(err => console.log(err))
}
//end edit

const ProductUpdate = (contents) => {

  getToken();
  const content = {
    ...contents,
    ...data_user
  }

  console.log(content)

  const url = API_SERVICES.ProductUpdate;
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  }

  return axios(configFetch(url, 'put', content, true, extraHeaders))
    .then(result => result.data)
    .catch(err => console.log(err))
}

//update ebook
const ProductUpdateEbook = (contents) => {

  getToken();
  const content = {
    ...contents,
    ...data_user
  }

  console.log(content)

  const url = API_SERVICES.ProductUpdateEbook;
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  }

  return axios(configFetch(url, 'put', content, true, extraHeaders))
    .then(result => result.data)
    .catch(err => console.log(err))
}


//update imprint
const ProductUpdateimprint = (contents) => {

  getToken();
  const content = {
    ...contents,
    ...data_user
  }

  console.log(content)

  const url = API_SERVICES.ProductUpdateimprint;
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  }

  return axios(configFetch(url, 'put', content, true, extraHeaders))
    .then(result => result.data)
    .catch(err => console.log(err))
}
//end update

//update ihsan
const ProductUpdateihsan = (contents) => {

  getToken();
  const content = {
    ...contents,
    ...data_user
  }

  console.log(content)

  const url = API_SERVICES.ProductUpdateihsan;
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  }

  return axios(configFetch(url, 'put', content, true, extraHeaders))
    .then(result => result.data)
    .catch(err => console.log(err))
}
//end update

//update inspirasi
const ProductUpdateinspirasi = (contents) => {

  getToken();
  const content = {
    ...contents,
    ...data_user
  }

  console.log(content)

  const url = API_SERVICES.ProductUpdateinspirasi;
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  }

  return axios(configFetch(url, 'put', content, true, extraHeaders))
    .then(result => result.data)
    .catch(err => console.log(err))
}

//end update

//update idea
const ProductUpdateidea = (contents) => {

  getToken();
  const content = {
    ...contents,
    ...data_user
  }

  console.log(content)

  const url = API_SERVICES.ProductUpdateidea;
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  }

  return axios(configFetch(url, 'put', content, true, extraHeaders))
    .then(result => result.data)
    .catch(err => console.log(err))
}
//end update



const ProductDelete = (contents) => {

  getToken();
  const content = {
    ...contents,
    ...data_user
  }

  const url = API_SERVICES.ProductDelete;
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  }

  return axios(configFetch(url, 'delete', content, true, extraHeaders))
    .then(result => result.data)
    .catch(err => console.log(err))
}

//delete ebook

const ProductDeleteEbook = (contents) => {

  getToken();
  const content = {
    ...contents,
    ...data_user
  }

  const url = API_SERVICES.ProductDeleteEbook;
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  }

  return axios(configFetch(url, 'delete', content, true, extraHeaders))
    .then(result => result.data)
    .catch(err => console.log(err))
}



//delete imprint

const ProductDeleteimprint = (contents) => {

  getToken();
  const content = {
    ...contents,
    ...data_user
  }

  const url = API_SERVICES.ProductDeleteimprint;
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  }

  return axios(configFetch(url, 'delete', content, true, extraHeaders))
    .then(result => result.data)
    .catch(err => console.log(err))
}
//end delete

//delete ihsan
const ProductDeleteihsan = (contents) => {

  getToken();
  const content = {
    ...contents,
    ...data_user
  }

  const url = API_SERVICES.ProductDeleteihsan;
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  }

  return axios(configFetch(url, 'delete', content, true, extraHeaders))
    .then(result => result.data)
    .catch(err => console.log(err))
}
//end delete

//delete inspirasi
const ProductDeleteinspirasi = (contents) => {

  getToken();
  const content = {
    ...contents,
    ...data_user
  }

  const url = API_SERVICES.ProductDeleteinspirasi;
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  }

  return axios(configFetch(url, 'delete', content, true, extraHeaders))
    .then(result => result.data)
    .catch(err => console.log(err))
}
//end delete

//delete idea
const ProductDeleteidea = (contents) => {

  getToken();
  const content = {
    ...contents,
    ...data_user
  }

  const url = API_SERVICES.ProductDeleteidea;
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  }

  return axios(configFetch(url, 'delete', content, true, extraHeaders))
    .then(result => result.data)
    .catch(err => console.log(err))
}
//end delete


//journal crud

const ProductAddJournal = (contents) => {

  getToken();

  const content = {
    ...contents,
    ...data_user
  }

  console.log(content)

  const url = API_SERVICES.ProductAddJournal;
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  }

  return axios(configFetch(url, 'post', content, true, extraHeaders))
    .then(result => result.data)
    .catch(err => console.log(err))
}

const ProductEditJournal = (contents) => {

  getToken();
  const content = {
    ...contents,
    ...data_user
  }

  const url = API_SERVICES.ProductEditJournal;
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  }

  return axios(configFetch(url, 'post', content, true, extraHeaders))
    .then(result => result.data)
    .catch(err => console.log(err))
}

const ProductUpdateJournal = (contents) => {

  getToken();
  const content = {
    ...contents,
    ...data_user
  }

  console.log(content)

  const url = API_SERVICES.ProductUpdateJournal;
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  }

  return axios(configFetch(url, 'put', content, true, extraHeaders))
    .then(result => result.data)
    .catch(err => console.log(err))
}

const ProductDeleteJournal = (contents) => {

  getToken();
  const content = {
    ...contents,
    ...data_user
  }

  const url = API_SERVICES.ProductDeleteJournal;
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  }

  return axios(configFetch(url, 'delete', content, true, extraHeaders))
    .then(result => result.data)
    .catch(err => console.log(err))
}



const ProductCategoryGeneral = (contents) => {

  getToken();
  const content = {
    ...contents,
    ...data_user
  }

  const url = API_SERVICES.ProductCategoryGeneral;
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  }

  return axios(configFetch(url, 'get', content, true, extraHeaders)).then(result => result.data).catch(err => console.log(err))
}


const ProductPenerbitGeneral = (contents) => {

  getToken();
  const content = {
    ...contents,
    ...data_user
  }

  const url = API_SERVICES.ProductPenerbitGeneral;
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  }

  return axios(configFetch(url, 'get', content, true, extraHeaders)).then(result => result.data).catch(err => console.log(err))
}



const ProductCategory = () => {

  getToken();
  const url = API_SERVICES.ProductCategory;
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  }
  return axios(configFetch(url, 'get', null, true, extraHeaders)).then(result => result.data).catch(err => console.log(err))
}

// WRITE NEW PRODUCT LOCAL CATEGORY
const NewCategoryAction = (contents) => {

  getToken();
  const content = {
    ...contents,
    ...data_user
  }

  const url = API_SERVICES.CategoryProductLocalAdd;
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  }

  return axios(configFetch(url, 'post', content, true, extraHeaders))
    .then(result => result.data)
    .catch(err => console.log(err))
}

// AUTHOR    
const AuthorIndex = (contents) => {

  getToken();
  const content = {
    ...contents,
    ...data_user
  }

  const url = API_SERVICES.AuthorIndex;
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  }

  return axios(configFetch(url, 'get', content, true, extraHeaders))
    .then(result => result.data).catch(err => console.log(err));
}

const AuthorCreate = (contents) => {

  getToken();
  const content = {
    ...contents,
    ...data_user
  }

  const url = API_SERVICES.AuthorCreate;
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  }

  return axios(configFetch(url, 'post', content, true, extraHeaders))
    .then(result => result.data)
    .catch(err => console.log(err))
}

//SLIDEBAR

const getSlidebar = (contents) => {
  getToken()
  const content = {
    ...contents,
    ...data_user
  }

  const url = API_SERVICES.SlideBarGet;
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  }

  return axios(configFetch(url, 'post', content, true, extraHeaders))
    .then(result => result.data)
    .catch(err => console.log(err))
}

const CreateSlidebar = (contents) => {
  getToken();
  const content = {
    ...contents,
    ...data_user
  }

  const url = API_SERVICES.SlideBarCreate;
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  }

  return axios(configFetch(url, 'post', content, true, extraHeaders))
    .then(result => result.data)
    .catch(err => console.log(err))
}

const updateSlidebar = (contents) => {
  getToken();
  const content = {
    ...contents,
    ...data_user
  }

  const url = API_SERVICES.SlideBarUpdate;
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  }

  return axios(configFetch(url, 'put', content, true, extraHeaders))
    .then(result => result.data)
    .catch(err => console.log(err))
}

const deleteSlidebar = (contents) => {
  getToken();
  const content = {
    ...contents,
    ...data_user
  }

  const url = API_SERVICES.SlideBarDelete;
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  }

  return axios(configFetch(url, 'delete', content, true, extraHeaders))
    .then(result => result.data)
    .catch(err => console.log(err))
}

// // SLIDER Publisher
// GET satu data slider publisher by id
const getSliderPublisherById = (id) => {
  getToken();

  const url = `${HOSTNAME}/slider-publisher/${id}`;
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  };

  return axios(configFetch(url, 'get', null, true, extraHeaders))
    .then(result => result.data)
    .catch(err => console.log(err));
};

const getSliderPublisher = (contents) => {
  getToken();
  const content = {
    ...contents,
    ...data_user
  }

  const url = API_SERVICES.SliderPublisherGet; 
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  }

  return axios(configFetch(url, 'post', content, true, extraHeaders))
    .then(result => result.data)
    .catch(err => console.log(err))
}

const CreateSliderPublisher = (contents) => {
  getToken();
  const content = {
    ...contents,
    ...data_user
  }

  const url = API_SERVICES.SliderPublisherCreate; // Menggunakan konstanta SliderImprintCreate
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  };

  return axios(configFetch(url, 'post', content, true, extraHeaders))
    .then(result => result.data)
    .catch(err => console.log(err))
};

const updateSliderPublisher = (contents) => {
  getToken();
  const content = {
    ...contents,
    ...data_user
  }

  const url = API_SERVICES.SliderPublisherUpdate; // Menggunakan konstanta SliderPublisherUpdate
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  }

  return axios(configFetch(url, 'put', content, true, extraHeaders))
    .then(result => result.data)
    .catch(err => console.log(err));
}

const deleteSliderPublisher = (contents) => {
  getToken();
  const content = {
    ...contents,
    ...data_user
  }

  const url = API_SERVICES.SliderPublisherDelete; // Menggunakan konstanta SliderPublisherDelete
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  }

  return axios(configFetch(url, 'delete', content, true, extraHeaders))
    .then(result => result.data)
    .catch(err => console.log(err));
}

// // SLIDERPUBLISHER YG INI
// // get
// const getSliderPublisher = async (contents) => {
//   getToken();
//   const content = { ...contents, ...data_user };
//   const url = API_SERVICES.SliderPublisherGet;
//   const extraHeaders = { Authorization: `Bearer ${localStorage.getItem('token')}` };

//   const res = await axios(configFetch(url, 'post', content, true, extraHeaders));
//   return res.data; // { result, exe_time }
// };

// // create
// const CreateSliderPublisher = async (contents) => {
//   getToken();
//   const content = { ...contents, ...data_user };
//   const url = API_SERVICES.SliderPublisherCreate;
//   const extraHeaders = { Authorization: `Bearer ${localStorage.getItem('token')}` };

//   const res = await axios(configFetch(url, 'post', content, true, extraHeaders));
//   return res.data; // { status, message, data }
// };

// // update
// const updateSliderPublisher = async (contents) => {
//   getToken();
//   const content = { ...contents, ...data_user };
//   const url = API_SERVICES.SliderPublisherUpdate;
//   const extraHeaders = { Authorization: `Bearer ${localStorage.getItem('token')}` };

//   const res = await axios(configFetch(url, 'put', content, true, extraHeaders));
//   return res.data; // { status, message, data }
// };

// // delete
// const deleteSliderPublisher = async (contents) => {
//   getToken();
//   const content = { ...contents, ...data_user };
//   const url = API_SERVICES.SliderPublisherDelete;
//   const extraHeaders = { Authorization: `Bearer ${localStorage.getItem('token')}` };

//   const res = await axios(configFetch(url, 'delete', content, true, extraHeaders));
//   return res.data; // { status, message }
// };




// MATERIAL    
const MaterialIndex = (contents) => {

  getToken();
  const content = {
    ...contents,
    ...data_user
  }

  const url = API_SERVICES.MaterialIndex;
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  }

  return axios(configFetch(url, 'get', content, true, extraHeaders))
    .then(result => result.data).catch(err => console.log(err));
}

const MaterialCreate = (contents) => {

  getToken();

  const content = {
    ...contents,
    ...data_user
  }

  const url = API_SERVICES.MaterialCreate;
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  }

  return axios(configFetch(url, 'post', content, true, extraHeaders))
    .then(result => result.data)
    .catch(err => console.log(err))
}

const ListPayment = (contents) => {

  getToken();

  const content = {
    ...contents,
    ...data_user
  }

  const url = API_SERVICES.ListPayment;
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  }

  return axios(configFetch(url, 'post', content, true, extraHeaders))
    .then(result => result.data)
    .catch(err => console.log(err))
}

const WaitingPayment = (contents) => {

  getToken();

  const content = {
    ...contents,
    ...data_user
  }

  const url = API_SERVICES.WaitingPayment;
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  }

  return axios(configFetch(url, 'post', content, true, extraHeaders))
    .then(result => result.data)
    .catch(err => console.log(err))
}

const ConfirmPayment = (contents) => {

  getToken();

  const content = {
    ...contents,
    ...data_user
  }

  const url = API_SERVICES.ConfirmPayment;
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  }

  return axios(configFetch(url, 'put', content, true, extraHeaders))
    .then(result => result.data)
    .catch(err => console.log(err))
}

const RejurnalPayment = (contents) => {

  getToken();

  const content = {
    ...contents,
    ...data_user
  }

  const url = API_SERVICES.RejurnalPayment;
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  }

  return axios(configFetch(url, 'put', content, true, extraHeaders))
    .then(result => result.data)
    .catch(err => console.log(err))
}

const ListOrder = (contents) => {

  getToken();

  const content = {
    ...contents,
    ...data_user
  }

  const url = API_SERVICES.ListOrder;
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  }

  return axios(configFetch(url, 'post', content, true, extraHeaders))
    .then(result => {
      return result.data
    }
    )
    .catch(err => console.log(err))
}

const ListOrderDetail = (contents) => {

  getToken();

  const content = {
    ...contents,
    ...data_user
  }

  const url = API_SERVICES.ListOrderDetail;
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  }

  return axios(configFetch(url, 'post', content, true, extraHeaders))
    .then(result => result.data)
    .catch(err => console.log(err))
}

const ConfirmSend = (contents) => {

  getToken();

  const content = {
    ...contents,
    ...data_user
  }

  const url = API_SERVICES.UpdateResi;
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  }

  return axios(configFetch(url, 'put', content, true, extraHeaders))
    .then(result => result.data)
    .catch(err => console.log(err))
}

const ListEmployee = (contents) => {

  getToken();

  const content = {
    ...contents,
    ...data_user,
  }

  // const id = data_user.companyId;
  const url = API_SERVICES.ListEmployee;
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  }

  return axios(configFetch(url, 'post', content, true, extraHeaders))
    .then(result => result.data.data)
    .catch(err => console.log(err))
}

const TakeThisOrder = (contents) => {
  getToken();
  const content = {
    ...contents,
    ...data_user,
  }
  // const id = data_user.companyId;
  const url = API_SERVICES.TakeThisOrder;
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  }
  return axios(configFetch(url, 'post', content, true, extraHeaders))
    .then(result => result.data)
    .catch(err => console.log(err))
}

const DeclineThisOrder = (contents) => {
  getToken();
  const content = {
    ...contents,
    ...data_user,
  }
  // const id = data_user.companyId;
  const url = API_SERVICES.DeclineThisOrder;
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  }
  return axios(configFetch(url, 'post', content, true, extraHeaders))
    .then(result => result.data)
    .catch(err => console.log(err))
}

const TrackingShip = (contents) => {
  getToken();
  const content = {
    ...contents,
    ...data_user
  }
  const url = API_SERVICES.TrackingShip;
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  }
  return axios(configFetch(url, 'post', content, true, extraHeaders))
    .then(result => result.data)
    .catch(err => console.log(err))
}

const ListStatus = (contents) => {
  getToken();
  const content = {
    ...contents,
    ...data_user
  }
  const url = API_SERVICES.ListStatus;
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  }
  return axios(configFetch(url, 'post', content, true, extraHeaders))
    .then(result => result.data)
    .catch(err => console.log(err))
}

const DashboardStat = (contents) => {
  getToken();
  const content = {
    ...contents,
    ...data_user
  }

  const url = API_SERVICES.DashboardStat;
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  }
  return axios(configFetch(url, 'post', content, true, extraHeaders))
    .then(result => result.data)
    .catch(err => console.log(err))
}

const CategoryListCompany = (contents) => {
  getToken();
  const content = {
    ...contents,
    ...data_user
  }
  const url = API_SERVICES.CategoryListCompany;
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  }
  return axios(configFetch(url, 'post', content, true, extraHeaders))
    .then(result => result.data)
    .catch(err => console.log(err))
}

const ListBranch = (contents) => {
  getToken();
  const content = {
    ...contents,
    ...data_user
  }
  const url = API_SERVICES.BranchList;
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  }
  return axios(configFetch(url, 'post', content, true, extraHeaders))
    .then(result => result.data)
    .catch(err => console.log(err))
}

// mengarahkan untuk produk diletakkan di branch yang mana
const CheckBranchChosen = (contents) => {
  getToken();
  const content = {
    ...contents,
    ...data_user
  }
  const url = API_SERVICES.CheckBranchChosen;
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  }
  return axios(configFetch(url, 'post', content, true, extraHeaders))
    .then(result => result.data)
    .catch(err => console.log(err))
}

const SetBranchSetting = async (contents) => {
  await getToken();

  const content = {
    ...contents,
    ...data_user
  }

  const url = API_SERVICES.SetBranchSetting;
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  }
  return axios(configFetch(url, 'post', content, true, extraHeaders))
    .then(result => result.data)
    .catch(err => console.log(err))
}

const CheckAccountFinance = (contents) => {
  getToken();

  const content = {
    ...contents
  }

  const url = API_SERVICES.CheckAccountFinance;
  const extraHeaders = {
    Authorization: `Bearer ` + localStorage.getItem('token')
  }
  return axios(configFetch(url, 'post', content, true, extraHeaders))
    .then(result => result.data)
    .catch(err => console.log(err))
}






export {
  ProductList,
  ProductAdd,
  ProductEdit,
  ProductUpdate,
  ProductDelete,
  ProductCategoryGeneral,
  ProductPenerbitGeneral,

  ProductAddJournal,
  ProductEditJournal,
  ProductUpdateJournal,
  ProductDeleteJournal,

  ProductListEbook,
  ProductAddEbook,
  ProductEditEbook,
  ProductUpdateEbook,
  ProductDeleteEbook,

  ProductListImprint,
  ProductAddimprint,
  ProductEditimprint,
  ProductUpdateimprint,
  ProductDeleteimprint,

  ProductListIhsan,
  ProductAddihsan,
  ProductEditihsan,
  ProductUpdateihsan,
  ProductDeleteihsan,

  ProductListInspirasi,
  ProductAddinspirasi,
  ProductEditinspirasi,
  ProductUpdateinspirasi,
  ProductDeleteinspirasi,

  ProductListIdea,
  ProductAddidea,
  ProductEditidea,
  ProductUpdateidea,
  ProductDeleteidea,


  NewCategoryAction,
  ProductCategory,

  AuthorIndex,

  MaterialIndex,
  MaterialCreate,
  AuthorCreate,
  data_user,

  CreateSlidebar,
  getSlidebar,
  updateSlidebar,
  deleteSlidebar,

  CreateSliderPublisher,
  getSliderPublisher,
  updateSliderPublisher,
  deleteSliderPublisher,
  getSliderPublisherById,

   

  //product journal
  ProductListJournal,

  // Payment Confirmation
  ListStatus,
  ListPayment,
  WaitingPayment,
  ConfirmPayment,
  RejurnalPayment,
  ListOrder,
  ConfirmSend,
  ListOrderDetail,

  ListEmployee,
  TakeThisOrder,
  DeclineThisOrder,
  TrackingShip,

  DashboardStat,
  CategoryListCompany,
  ListBranch,
  CheckBranchChosen,
  SetBranchSetting,
  // cek integrasi ke tblAccount,
  CheckAccountFinance,
  FindTransactionId
}